module.exports = __webpack_public_path__ + "static/media/signage-indoor-img27.a9a26975.jpg";